export const REALM_DOMAINS: Record<string, string> = {
  CVS: 'https://www.cvs.com',
  H100: 'https://www.health100.com'
};

export const CONS = {
  title: 'Generate a new app feedback link',
  realm_id_selector: 'App',
  app_store_selector: 'App store',
  app_store_username: 'App store username',
  original_review: 'Original user review',
  review_date: 'App Store review date',
  feedback_link_header: 'Provide the following link to the user in the app store:',
  feedback_link: '/feedback?xid=',
  generate_link: 'Submit the above form to generate the link.',
  copy: 'Copy link',
  copy_successful: 'Link copied to clipboard!'
};

export const LINK_GENERATION_ERROR_TITLES = {
  DEFAULT: 'Correct the following errors'
};
export const LINK_GENERATION_VALIDATION = {
  REALM_ID_REQUIRED: 'Select an app',
  REALM_ID_INVALID: 'App must be H100 or CVS',
  APP_STORE_REQUIRED: 'Select an app store',
  APP_STORE_INVALID: 'App store must be Apple or Google',
  APP_STORE_USERNAME_REQUIRED: 'Please include the user\'s app store username',
  APP_STORE_USERNAME_INVALID: 'The user\'s app store username must be less than 40 characters',
  ORIGINAL_REVIEW_REQUIRED: 'Please include the original app store review',
  ORIGINAL_REVIEW_INVALID: 'The original app store review must be less than 6000 characters',
  REVIEW_DATE_REQUIRED: 'Please include the review date',
  REVIEW_DATE_INVALID: 'The review date cannot be from the future',
};
